import type from "../commons/hospitalActionStatus";

const DEFAULT_STATE = {
    complaints: [],
    risks: [],
    error: null,
    requestState: false,
    status: null,
};

export const hospitalReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let complaints;
    let risks;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    switch (actionType) {
        case type.GET_COMPLAINTS_REQUEST:
            return { ...state, complaints: [],risks:[], requestState, status };

        case type.GET_COMPLAINTS_SUCCESS:
            complaints = action.result;
            return {
                ...state,
                complaints,
                requestState,
                status,
            };

        case type.GET_COMPLAINTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_RISKS_REQUEST:
            return { ...state, complaints: [],risks:[],requestState, status };

        case type.GET_RISKS_SUCCESS:
            risks = action.result;
            return {
                ...state,
                risks,
                requestState,
                status,
            };

        case type.GET_RISKS_FAILURE:
            return { ...state, error, requestState, status };

        default:
            return state;
    }
};
